import { num } from '../store/cartStore.js';
// Totales de una cuenta guardada: mismo cálculo que usa el servidor.
export const tabTotal = (tab) =>
  Math.max(0, (tab.items ?? []).reduce((s, i) => s + num(i.total), 0) - num(tab.discount));

export const tabItemCount = (tab) =>
  (tab.items ?? []).reduce((s, i) => s + i.quantity, 0);
